import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy,Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatChip, MatChipSet } from '@angular/material/chips';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { AdminComponentBase } from 'app/layout/content/admin-component-base';
import { AuthorizationContext, AuthorizationService } from 'app/shared/authentication';
import { LinkifiedTextComponent } from 'app/shared/components/linkified-text.component';
import { GlobalPermission } from 'app/shared/graph';
import { CopyToClipboardComponent } from 'app/shared/utilities/copy-to-clipboard.component';
import { FromNowPipe } from 'app/shared/utilities/from-now.pipe';
import { TruncatePipe } from 'app/shared/utilities/truncate.pipe';

import { GroupedLogs } from './store-logs-page.component';

@Component({
    templateUrl: './store-logs-group.component.html',
    styleUrls: ['./store-logs-group.component.scss'],
    selector: 'admin-store-logs-group',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatTooltip, MatIcon, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatChipSet, MatChip, NgClass, CopyToClipboardComponent, DatePipe, FromNowPipe, TruncatePipe, LinkifiedTextComponent]
})
export class StoreLogsGroupComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly observer = inject(BreakpointObserver);
    private readonly authService = inject(AuthorizationService);

    @Input() storeLogs: GroupedLogs[] = [];
    authContext?: AuthorizationContext;

    maxMessageLength = 100;
    maxMessageLengthByScreenSize = new Map([
        [Breakpoints.XSmall, 15],
        [Breakpoints.Small, 40],
        [Breakpoints.Medium, 90],
        [Breakpoints.Large, 110],
        [Breakpoints.XLarge, 130]
    ]);

    ngOnInit(): void {
        this.registerSubscription(this.observer.observe([
            Breakpoints.XSmall,
            Breakpoints.Small,
            Breakpoints.Medium,
            Breakpoints.Large,
            Breakpoints.XLarge
        ]).subscribe(result => {
            for (const query of Object.keys(result.breakpoints)) {
                if (result.breakpoints[query]) {
                    this.maxMessageLength = this.maxMessageLengthByScreenSize.get(query) ?? 100;
                }
            }
        }));

        this.authService.authorizationContext().subscribe(authContext => this.authContext = authContext);
    }

    ngOnDestroy(): void {
        this.unsubscribeSubscriptions();
    }

    canReadApplicationInsightsLogs() {
        return this.authContext?.hasGlobalPermissions(GlobalPermission.ReadApplicationInsightsLogs);
    }
}
